import React from 'react';

const Arrow = () =>
<svg xmlns="http://www.w3.org/2000/svg" width="22.635" height="15.704" viewBox="0 0 22.635 15.704">
  <g id="Group_13058" data-name="Group 13058" transform="translate(-406.365 -2656)">
    <line id="Line_163" data-name="Line 163" x1="20.351" transform="translate(406.365 2664.128)" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.6"/>
    <path id="Path_2862" data-name="Path 2862" d="M421.154,2656.836l6.119,7.292-6.119,6.7" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.6"/>
  </g>
</svg>;

export default Arrow;
